import { makeAutoObservable, observable  } from "mobx";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { SettingService } from "../services/settingservice";
class SettingStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedKey = "1";
  dailyProdTabSelKey = "1";
  isworking = false;
  flashSettings = {};
  flashSettingsLoaded = false;
  isflashSettingsModified = false;
  isSaving = false;

  async loadFlashSettings() {
    try {
      if (!this.flashSettingsLoaded) {
        const res = await SettingService.loadFlashSettings();

        this.flashSettingsLoaded = true;
        this.flashSettings = res;
        //console.log(res);
      }
    } catch (error) {
      throw error;
    }
  }

  async saveFlashSettings() {
    try {
      this.isSaving = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const retval = await SettingService.saveFlasSettings(
        this.flashSettings,
        uploadedBy
      );
      return retval;
    } catch (error) {
      throw error;
    }
  }
}

const settingStore = new SettingStore();
export default settingStore;

